<template>
  <div class="PaymentRecord">
    <!-- 消费记录 -->
    <el-row>
      <el-form :inline="true" :model="quertForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-autocomplete v-model.trim="quertForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
            :fetch-suggestions="querySearchAsync" @select="handleOlderSelect" style="width: 130px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-input v-model.trim="quertForm.name" auto-complete="off" placeholder="输入费用类型" style="width: 120px">
          </el-input>
        </el-form-item>
        <el-form-item label="是否销账">
          <el-select v-model="quertForm.isRecharge" clearable placeholder="是否销账" style="width:120px" filterable>
            <el-option label="未销账" value="0"></el-option>
            <el-option label="已销账" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣费方式">
          <el-select v-model="quertForm.type" clearable placeholder="选择扣费方式" style="width:130px" filterable>
            <el-option label="每日扣费" value="0"></el-option>
            <el-option label="月度扣费" value="1"></el-option>
            <el-option label="按次扣费" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="quertForm.timevalue" unlink-panels type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" style="width:220px" value-format="yyyy-MM-dd" clearable></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="queryTable">查询</el-button>
          <el-button type="warning" icon="el-icon-plus" plain @click="oldConsumption">添加扣费</el-button>
          <!-- 新增批量销账按钮 -->
          <el-button 
            type="danger" 
            icon="el-icon-check" 
            plain 
            @click="batchSettle"
            :disabled="selectedIds.length === 0"
          >
            批量销账
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table 
        :data="tableData" 
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }" 
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" 
        :row-style="tableRowStyle" 
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
      >
        <!-- 新增勾选列 -->
        <el-table-column 
          type="selection" 
          width="55"
          :selectable="canSelectRow"
        ></el-table-column>
        
        <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" width="200px" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectType" label="费用类型" align="center"></el-table-column>
        <el-table-column prop="projectName" label="扣费项目" align="center"></el-table-column>
        <el-table-column prop="type" label="扣费方式" :formatter="formatType" align="center"></el-table-column>
        <el-table-column prop="consumptionFee" label="扣费金额" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="扣费时间" align="center" width="180px"></el-table-column>
        <el-table-column prop="isRecharge" label="是否销账" align="center" width="140px" :formatter="formatRecharge"></el-table-column>
        <el-table-column label="操作" align="center" width="90px">
          <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.status!=1" plain @click="handleEdit(scope.row)">销账</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination class="fenye" background layout="total,prev, pager, next" :total="total" :current-page.sync="pageNum"
      @current-change="changePage" align="center"></el-pagination>

    <el-dialog title="新增扣费" :visible.sync="dialogConsumptionVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" width="420px">
      <el-form ref="form" :model="chargeForm">
        <el-form-item label="长者姓名" :label-width="formLabelWidth" prop="oldmanId">
          <el-autocomplete v-model.trim="chargeForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
            :fetch-suggestions="querySearchAsync2" @select="handleOlderSelect2" style="width: 240px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <p>{{ chargeForm.oldIdCard }}</p>
        </el-form-item>
        <el-form-item label="费用类型" :label-width="formLabelWidth">
          <el-input v-model="chargeForm.projectType" placeholder="请输入缴费类型" clearable style="width: 240px"></el-input>
        </el-form-item>
        <el-form-item label="扣费项目" :label-width="formLabelWidth">
          <el-input v-model="chargeForm.projectName" placeholder="请输入缴费项目" clearable style="width: 240px"></el-input>
        </el-form-item>
        <el-form-item label="扣费日期" :label-width="formLabelWidth" prop="chargeDay">
          <el-date-picker
            v-model="chargeForm.chargeDay"
            type="date"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费金额" :label-width="formLabelWidth" prop="consumptionFee">
          <el-input v-model.trim="chargeForm.consumptionFee" placeholder="请输入缴费金额" @input="inputChange1"
            style="width: 240px">
            <span slot="suffix">/ 元 </span>
          </el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogConsumptionVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="chargeLoading">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      tableData: [], //老人列表数据
      quertForm: {
        oldName: "", //搜索查询老人
        oldIdCard: "", //搜索查询老人身份证
        type: null,
        isRecharge: "",
        statusList: [0, 1, 2],
      },
      dialogConsumptionVisible: false,
      formLabelWidth: "100px",
      chargeForm: {},
      chargeLoading: false,
      //分页
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      checkBill: [],
      feeTree:[],
      feeItem:[],
      selectedIds: [], // 选中的记录ID数组
      selectedRows: [] // 选中的行数据
    };
  },
  methods: {
    formatRecharge(row){
        // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
        if(row.status == 0){
          return "未销账";
        }else if(row.status == 1){
          return "已销账";
        }else{
          return "未销账";
        }
    },
    handleEdit(row) {
      this.$confirm("是否确认销账?", "确认销账", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.$postJson(`omc/account/settleBatch`,{
            recordIds: [row.id],
            status:1,
            totalAmount: row.consumptionFee,
            operator: sessionStorage.getItem("uerName")
          }).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryPayList();
            // 清除选中状态
            this.selectedIds = [];
            this.selectedRows = [];
            this.$refs.multipleTable.clearSelection();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 批量销账方法
    batchSettle() {
      if (this.selectedIds.length === 0) {
        this.$message.warning("请先选择要销账的记录");
        return;
      }

      // 计算总金额
      const totalAmount = this.selectedRows.reduce((sum, row) => {
        return sum + Number(row.consumptionFee || 0);
      }, 0);

      this.$confirm(`是否确认对选中的${this.selectedIds.length}条记录进行批量销账?`, "批量销账确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.$postJson(`omc/account/settleBatch`,{
            recordIds: this.selectedIds,
            status: 1,
            totalAmount: totalAmount,
            operator: sessionStorage.getItem("uerName")
          }).then(res => {
            if (res.code == 200) {
              this.$message({ message: `批量销账成功，共销账${this.selectedIds.length}条记录`, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryPayList();
            // 清除选中状态
            this.selectedIds = [];
            this.selectedRows = [];
            this.$refs.multipleTable.clearSelection();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消批量销账"
          });
        });
    },
    // 勾选事件处理
    handleSelectionChange(val) {
      this.selectedRows = val;
      // 提取选中的ID
      this.selectedIds = val.map(row => row.id);
    },
    // 控制是否可勾选（只有未结算的记录可勾选）
    canSelectRow(row) {
      return row.status !== 1; // status=1是已结算，不可勾选
    },
    getFeeTree(){
      this.$postForm("mdc/dict/queryDictSubListByDictCode/feeType", {dictCode:"feeType"}).then(res=>{
        this.feeTree = res.result;
      })
    },
    /* 
      模糊查询老人
    */
    querySearchAsync2(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect2(item) {
      this.chargeForm.oldmanId = item.oldmanId;
      this.chargeForm.oldIdCard = item.oldIdCard;
      console.log(this.chargeForm);
    },
    /* 
     模糊查询老人
     */
    inputChange1(val) {
      //限制输入数字和两位小数;
      this.chargeForm.consumptionFee = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    oldConsumption() {
      this.dialogConsumptionVisible = true;
      this.chargeForm = {
        oldmanId: "",
        consumptionFee: "",
        projectType: "",
        projectName: "",
        chargeDay:util.formatDate.format(new Date(), "yyyy-MM-dd"),
      }
    },
    submitForm() {
      console.log(this.chargeForm);
      if (this.chargeForm.oldmanId == null || this.chargeForm.oldmanId == '') {
        this.$message.warning("请选择长者姓名");
        return;
      }
      if (this.chargeForm.consumptionFee == null || this.chargeForm.consumptionFee == '') {
        this.$message.warning("请输入缴费金额");
        return;
      }
      if (this.chargeForm.projectType == null || this.chargeForm.projectType == '') {
        this.$message.warning("请输入费用类型");
        return;
      }
      if (this.chargeForm.projectName == null || this.chargeForm.projectName == '') {
        this.$message.warning("请输入扣费项目");
        return;
      }
      this.chargeLoading = true;
      console.log(this.chargeForm);
      var params = {
        oldId: this.chargeForm.oldmanId,
        createdTime: this.chargeForm.chargeDay+" 00:00:00",
        consumptionFee: this.chargeForm.consumptionFee,
        projectType: this.chargeForm.projectType,
        projectName: this.chargeForm.projectName,
      }
      this.$postJson("omc/account/oldConsumption", params).then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          this.chargeLoading = false;
          this.dialogConsumptionVisible = false;
          this.queryPayList();
          this.$message({ message: "添加成功", type: "success" });
        } else {
          this.chargeLoading = false;
          this.$message({ message: res.message, type: "error" });
        }
      });

    },


    /* 
     模糊查询老人
     */
    querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.quertForm.oldmanId = item.oldmanId;
      this.quertForm.oldIdCard = item.oldIdCard;
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    formatType(row) {
      // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
      if (row.type == 0) {
        return "按天消费";
      } else if (row.type == 1) {
        return "按月消费";
      } else if (row.type == 2) {
        return "按次收费";
      } else if (row.type == 5) {
        return "充值";
      } else {
        return "其他费用";
      }
    },
    //查询欠费列表
    queryPayList() {
      if (this.quertForm.oldName == null || this.quertForm.oldName == '') {
        this.quertForm.oldmanId = null;
      }
      let param = {
        oldId: this.quertForm.oldmanId,
        type: this.quertForm.type,
        name: this.quertForm.name,
        // statusList: this.quertForm.statusList,
        status: this.quertForm.isRecharge,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.quertForm.timevalue != null && this.quertForm.timevalue.length == 2) {
        param.startDay = this.quertForm.timevalue[0];
        param.endDay = this.quertForm.timevalue[1];
      }
      this.$postJson("omc/account/queryConsumptionList", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
        // 重新查询后清除选中状态
        this.selectedIds = [];
        this.selectedRows = [];
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    //回车enter回车查询
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    //搜索查询搜索查询
    queryTable() {
      this.pageNum = 1;
      this.queryPayList();
    },
    //分页
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.queryPayList(); //刷新欠费列表的数据
  },
};
</script>
<style lang="scss" scoped>
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}

.are {
  color: #369a52;
}

.no {
  color: red;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

/* 调整勾选框列的样式 */
::v-deep .el-table-column--selection .el-checkbox__inner {
  width: 16px;
  height: 16px;
}

::v-deep .el-table-column--selection .el-checkbox {
  margin-right: 0;
}
</style>